import Back1 from "../Back1";
import Back2 from "../Back2";
import Back3 from "../Back3";
import { Container } from "./styles";

export default function BackGround() {
    return(
        <Container>
            <Back1 />
            <Back2 />
            <Back3 />
        </Container>
    )
}